import { render, staticRenderFns } from "./BlobDownload.vue?vue&type=template&id=c4cefc20"
import script from "./BlobDownload.vue?vue&type=script&lang=js"
export * from "./BlobDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports